import { FormLayout, Modal, Select, Spinner, TextField } from '@shopify/polaris';
import React from 'react';
import ShopifyCountriesConfig from '../../../../../assets/ShopifyCountries';
const AddressEditModal = ({addressData,setAddressData,handleEditAddress,saveAddress,handleAddressInputChange})=> {

     // 是否需要检测税费
     let isNeedCheckTaxCode = false;

     // 税号文本
     let taxCodeText = 'Tax code';
     switch (addressData?.country_code) {
       case 'BR':
         // 巴西税号特称
         taxCodeText = 'CPF';
         isNeedCheckTaxCode = true;
         break;
       case 'NO':
         // 挪威税号特称
         taxCodeText = 'VOEC';
         isNeedCheckTaxCode = true;
         break;
       case 'CL':
         isNeedCheckTaxCode = true;
         break;
       default:
     }
    return (
        <Modal
        open={addressData.editAddressModalActive}
        onClose={() => handleEditAddress(0,addressData.editRecordId,false)}
        title={(addressData.editRecordId === 0) ? 'Add new address' :'Edit address'}
        primaryAction={{
          content: 'Save',
          onAction: () => saveAddress((addressData.editRecordId === 0) ? 'add' : 'update'),
          loading: addressData.saveDataLoading
        }}
        secondaryActions={[
          {
            content: 'Cancel',
            onAction: () => handleEditAddress(0,addressData.editRecordId,false),
          }
        ]}
      >
        <Modal.Section>
          <FormLayout>
            <FormLayout.Group>
              <TextField id="first_name" label={"First name"} onChange={handleAddressInputChange} value={addressData.first_name} maxLength={50} />
              <TextField id="last_name" label={"Last name"} onChange={handleAddressInputChange} value={addressData.last_name} error={addressData.lastNameError} maxLength={50} />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField id="company" label={"Company"} onChange={handleAddressInputChange} value={addressData.company} maxLength={255} />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField id="address1" label={"Address"} onChange={handleAddressInputChange} value={addressData.address1} error={addressData.address1Error} maxLength={255} />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField id="address2" label={"Apartment, suite, etc. (optional)"} onChange={handleAddressInputChange} value={addressData.address2} maxLength={255} />
            </FormLayout.Group>
            
            <FormLayout.Group>
              <Select
                id="country_code"
                label={"Country/region"}
                options={ShopifyCountriesConfig}
                onChange={handleAddressInputChange}
                value={addressData.country_code}
                error={addressData.countryError}
              />
              {(addressData.provinceData.length > 0 && !addressData.loadingProvinceData) && (
                <Select
                  id="provinceCode"
                  label={addressData.provinceLabelText}
                  options={addressData.provinceData}
                  onChange={handleAddressInputChange}
                  value={addressData.provinceCode}
                />
              )}
              {
                addressData.loadingProvinceData && <div style={{ textAlign: 'center', marginTop: '30px'}}><Spinner size="small" /></div>
              }
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField id="city" label={"City"} onChange={handleAddressInputChange} value={addressData.city} error={addressData.cityError} maxLength={50} />
              <TextField id="zip" label={"ZIP/Postal code"} onChange={handleAddressInputChange} value={addressData.zip} error={addressData.zipCodeError} maxLength={30} />
            </FormLayout.Group>

            <FormLayout.Group>
              <TextField id="phone" label={"Phone"} onChange={handleAddressInputChange} value={addressData.phone} error={addressData.phoneError} maxLength={30} />
              <TextField id="email" type="email" label={"Email"} onChange={handleAddressInputChange} value={addressData.email} error={addressData.emailError} maxLength={50} />
            </FormLayout.Group>

            {/* 巴西税费 */}
            {isNeedCheckTaxCode && (
              <FormLayout.Group>
                <TextField
                  id="option1"
                  label={taxCodeText}
                  onChange={handleAddressInputChange}
                  value={addressData.option1}
                  error={addressData.option1Error}
                  maxLength={30}
                />
              </FormLayout.Group>
            )}
          </FormLayout>
        </Modal.Section>
      </Modal>
    );
}

export default AddressEditModal;
